import { TableCell, TableCellProps } from "@mui/material";
import * as React from "react";

interface IProps {
    children?: React.ReactNode;
    color?: MprcColors | "inherit";
}

type Props = IProps & TableCellProps;

export const MprcTableCell : React.FC<Props> = (props) => {
    const { children, color, ...rest } = props;
    return (
        <TableCell
            {...rest}
            sx={
                (theme) => ({
                    color: color == undefined
                        ? undefined
                        : color == "inherit"
                            ? "inherit"
                            : theme.palette[color!].main

                })
            }
        >
            {children}
        </TableCell>
    );
};
